import React, { Component } from 'react'
import { Route, Switch, HashRouter} from 'react-router-dom'

import Home from './pages/home/home'
import About from './pages/about/about'
import policy from './pages/policy/policy'
import policyinfo from './pages/policyinfo/policyinfo'
import industrialMap from './pages/industrialMap/industrialMap'
import industrialChain from './pages/industrialChain/industrialChain'
import service from './pages/service/service'
import serviceinfo from './pages/serviceinfo/serviceinfo'
import talents from './pages/talents/talents'
import talentsinfo from './pages/talentsinfo/talentsinfo'
import skill from './pages/skill/skill'
import skillinfo from './pages/skillinfo/skillinfo'
import notice from './pages/notice/notice'
import noticeinfo from './pages/noticeinfo/noticeinfo'
import project from './pages/project/project'
import projectinfo from './pages/projectinfo/projectinfo'
import policySearch from './pages/policySearch/policySearch'
import policySearchInfo from './pages/policySearchInfo/policySearchInfo'
import history from './pages/history/history'
import policyMatching from './pages/policyMatching/policyMatching'
import policyMatchingList from './pages/policyMatchingList/policyMatchingList'
import companyTest from './pages/companyTest/companyTest'
import result from './pages/result/result'
import activity from './pages/activity/activity'
import productinfo from './pages/productinfo/productinfo'
import signup from './pages/signup/signup'
import productSignup from './pages/productSignup/productSignup'

export default class router extends Component {
  render() {
    return (
      <HashRouter>
          <Switch>
            <Route exact path='/' component={Home}></Route>
            <Route exact path='/home' component={Home}></Route>
            <Route exact path='/about' component={About}></Route>
            <Route exact path='/policy' component={policy}></Route>
            <Route exact path='/policyinfo' component={policyinfo}></Route>
            <Route exact path='/industrialMap' component={industrialMap}></Route>
            <Route exact path='/industrialChain' component={industrialChain}></Route>
            <Route exact path='/service' component={service}></Route>
            <Route exact path='/serviceinfo' component={serviceinfo}></Route>
            <Route exact path='/talents' component={talents}></Route>
            <Route exact path='/talentsinfo' component={talentsinfo}></Route>
            <Route exact path='/skill' component={skill}></Route>
            <Route exact path='/skillinfo' component={skillinfo}></Route>
            <Route exact path='/notice' component={notice}></Route>
            <Route exact path='/noticeinfo' component={noticeinfo}></Route>
            <Route exact path='/project' component={project}></Route>
            <Route exact path='/projectinfo' component={projectinfo}></Route>
            <Route exact path='/policySearch' component={policySearch}></Route>
            <Route exact path='/policySearchInfo' component={policySearchInfo}></Route>
            <Route exact path='/history' component={history}></Route>
            <Route exact path='/policyMatching' component={policyMatching}></Route>
            <Route exact path='/policyMatchingList' component={policyMatchingList}></Route>
            <Route exact path='/companyTest' component={companyTest}></Route>
            <Route exact path='/result' component={result}></Route>
            <Route exact path='/activity' component={activity}></Route>
            <Route exact path='/productinfo' component={productinfo}></Route>
            <Route exact path='/signup' component={signup}></Route>
            <Route exact path='/productSignup' component={productSignup}></Route>

          </Switch>
      </HashRouter>
    )
  }
}
